const { createApp } = Vue

/* --- Testimonials Section --- */
if(document.getElementById("testimonialSection"))
{
    const testimonialsApp = createApp({
        data() {
            return {
                activeSlide: 2,
                testimonialPosition: -25,
                totalSlides: 6,
            }
        },
        methods: {
            switchReview: function(toShow)
            {
                let testimonialCount = document.getElementById("testimonialSection").querySelector('.sp-test-wrap').dataset.totalItems;
                this.totalSlides = testimonialCount

                let singleReview = document.getElementById("testimonialSection").querySelector('.sp-test-wrap .shopify-block').offsetWidth;
                var reviewsToMove = 50;
                var testimonialStart = 25

                if(window.innerWidth < 768) 
                {
                    reviewsToMove = 100;
                    testimonialStart = 0
                }

                switch(toShow)
                {
                    case 'prev':
                        if(this.activeSlide > 1) {
                            this.activeSlide = this.activeSlide - 1
                            this.testimonialPosition = this.testimonialPosition + reviewsToMove
                        }
                        else {
                            this.activeSlide = this.totalSlides
                            this.testimonialPosition =  this.testimonialPosition + ((this.totalSlides - 1) * reviewsToMove * -1)
                        }
                        break;
                    case 'next':
                        if(this.activeSlide < this.totalSlides) {
                            this.activeSlide = this.activeSlide + 1
                            this.testimonialPosition = this.testimonialPosition - reviewsToMove
                        }
                        else {
                            this.activeSlide = 1
                            this.testimonialPosition = testimonialStart
                        }
                        break;
                }  
            }
        },
        mounted() {
            if(window.innerWidth < 768) 
            {
                this.testimonialPosition = 0;
                this.activeSlide = 1;
            }
        }
    }).mount('#testimonialSection')
}

if (window.innerWidth < 1025) {
    const slider = document.querySelector(".nav-swiper");
    if (slider) {
        let swiper = new Swiper('.nav-swiper', {
            speed: 400,
            slidesPerView: 4,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 4,
                    spaceBetween: 10
                }
            }
        })
    }

    let navDropdown = document.querySelector('.secondary-nav details.details-header-menu');
    navDropdown.addEventListener("click", function (e) {
        window.location.href = navDropdown.querySelector('.menu__item').dataset.href
    });
}